module.exports = __webpack_public_path__ + "static/img/qr_code.e4f79531.png";